import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { berichtApi } from '../api';

export default function FinanzberichtPage() {
  const navigate = useNavigate();
  const [laden, setLaden] = useState(false);
  const [ergebnis, setErgebnis] = useState(null);
  const [fehler, setFehler] = useState('');

  async function senden() {
    setLaden(true); setFehler(''); setErgebnis(null);
    try {
      const res = await berichtApi.senden();
      setErgebnis(res.data.message);
    } catch(e) { setFehler(e.response?.data?.error || 'Fehler beim Senden'); }
    setLaden(false);
  }

  return (
    <div style={{ padding: '24px', maxWidth: '600px', margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
        <button onClick={() => navigate('/')} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer' }}>←</button>
        <h1 style={{ margin: 0, fontSize: '26px' }}>📧 Monatlicher Finanzbericht</h1>
      </div>

      <div style={{ background: 'white', borderRadius: '16px', padding: '32px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', textAlign: 'center' }}>
        <div style={{ fontSize: '64px', marginBottom: '16px' }}>📊</div>
        <h2 style={{ margin: '0 0 12px', color: '#1e293b' }}>Finanzbericht per E-Mail</h2>
        <p style={{ color: '#64748b', marginBottom: '24px', lineHeight: '1.6' }}>
          Der Bericht enthält eine Übersicht aller Verträge, Zahlungen, Sparverträge,
          bald ablaufende Kündigungsfristen und den Budget-Status.
          Er wird automatisch jeden <strong>1. des Monats um 08:00 Uhr</strong> gesendet.
        </p>

        <div style={{ background: '#f0fdf4', borderRadius: '10px', padding: '16px', marginBottom: '24px', textAlign: 'left' }}>
          <div style={{ fontWeight: '600', marginBottom: '8px', color: '#15803d' }}>📋 Der Bericht enthält:</div>
          {['Monatliche Gesamtkosten & Einzahlungen', 'Gesamtvermögen Sparverträge', 'Bald ablaufende Kündigungsfristen', 'Vertragskosten nach Kategorie', 'Sparverträge & Investments', 'Budget-Status'].map((item, i) => (
            <div key={i} style={{ color: '#374151', fontSize: '14px', padding: '4px 0' }}>✅ {item}</div>
          ))}
        </div>

        {ergebnis && (
          <div style={{ background: '#f0fdf4', color: '#15803d', padding: '12px', borderRadius: '8px', marginBottom: '16px', fontWeight: '600' }}>
            ✅ {ergebnis}
          </div>
        )}

        {fehler && (
          <div style={{ background: '#fee2e2', color: '#dc2626', padding: '12px', borderRadius: '8px', marginBottom: '16px' }}>
            ❌ {fehler}
          </div>
        )}

        <button onClick={senden} disabled={laden}
          style={{ width: '100%', padding: '14px', background: laden ? '#94a3b8' : '#6366f1', color: 'white', border: 'none',
            borderRadius: '10px', cursor: laden ? 'not-allowed' : 'pointer', fontWeight: '700', fontSize: '16px' }}>
          {laden ? '📤 Wird gesendet...' : '📧 Bericht jetzt senden'}
        </button>
      </div>
    </div>
  );
}
